

export class Modal {
	constructor() {
		this.modal = $('.m-login');
		this.body = $('body');
		this.open = $('.js-modal-login');
		this.close = $('.c-close-modal');
		this.overlay = $('.m-overlay');
		this.login = $('.m-content__login');
		this.psw = $('.m-content__psw');
		this.register = $('.m-content__register');
		this.btnPsw = $('.btn-psw');
		this.btnLogin = $('.btn-login');
		this.btnSend = $('.m-content__login .btn-send');
		this.btnSendRegistration = $('.m-content__register .btn-send');
		this.formRegistration = $('.m-content__register .contact-form');
		this.btnRetrieve = $('.m-content__psw .btn-send');
		this.btnNewPass = $('.m-content__retrieve .btn-send');
		this.btnRegister = $('.m-register__button');
		this.actions();
	}
	actions() {
		this.open.on('click', () => {
			this.modal.addClass('is-open');
			this.body.addClass('is-modal__open');
		});
		this.close.on('click', () => {
			this.modal.removeClass('is-open');
			this.body.removeClass('is-modal__open');
			$('.message-space').html('');
		});
		this.overlay.on('click', () => {
			this.modal.removeClass('is-open');
			this.body.removeClass('is-modal__open');
			$('.message-space').html('');
		});
		this.body.on('keyup', (e) => {
			if (e.keyCode == 27 && this.body.hasClass('is-modal__open')) {
				this.modal.removeClass('is-open');
				this.body.removeClass('is-modal__open');
			}

			if (e.keyCode == 13) {
				if ($('.m-content__psw').is(':visible')) {
					this.retrievePassword();
				}
				else {
					this.doLogin();
				}
			}

		});
		this.btnLogin.on('click', () => {
			this.login.show();
			this.psw.hide();
			this.register.hide();
			$('.message-space').html('');
		});
		this.btnPsw.on('click', () => {
			this.login.hide();
			this.psw.show();
			this.register.hide();
			$('.message-space').html('');
		});
		this.btnRegister.on('click', () => {
			this.login.hide();
			this.psw.hide();
			this.register.show();
			$('.message-space').html('');
		});


		this.btnSend.on('click', this.doLogin.bind(this));
		this.btnRetrieve.on('click', this.retrievePassword.bind(this));
		this.btnNewPass.on('click', this.newPassword.bind(this));
		this.btnSendRegistration.on('click', this.doRegistration.bind(this));

	}


	doLogin() {
		var email = $('.m-content__login #input-1').val();
		var password = $('.m-content__login #input-2').val();
		var lang = $( 'html' ).attr('lang');

		$.ajax({
			type: 'POST'
			, data: {
				email: email
				, password: password
				, lang: lang
			}
			, url: _url + 'ajax/ajax.login.php'
			, success: function (data) {
				if(data == 'already'){
					$('.message-space').html('<span class="messaggio-alert">'+_translations['account_not_active']+'</span>');
				}else if (data != 0) {
					$(window.location).attr('href', data);
				}else if(data == 0){
					$('.message-space').html('<span class="messaggio-errore">'+_translations['wrong_credentials']+'</span>');
				}
			}
		});
	}

	retrievePassword() {
		var email = $('.m-content__psw #input-1').val();
		var lang = $( 'html' ).attr('lang');

		$.ajax({
			type: 'POST'
			, data: {
				email: email,
				lang: lang
			}
			, url: _url + 'ajax/ajax.forgot_password.php'
			, success: function (data) {
				if (data > 0) {
					$('.message-space').html('<span class="messaggio-successo">'+_translations['email_send']+'</span>');
				}
				else {
					$('.message-space').html('<span class="messaggio-errore">'+_translations['email_inexistent']+'</span>');
				}
			}
		});
	}

	newPassword() {
		var new_password;
		var confilm_password;
		var token;
		new_password = $('.m-content__retrieve #input-1').val();
		confilm_password = $('.m-content__retrieve #input-2').val();
		token = $('.m-content__retrieve #input-3').val();
		if (new_password.length >= 8 && confilm_password.length >= 8) {
			if (new_password == confilm_password) {
				$.ajax({
					type: 'POST'
					, data: {
						password: new_password
						, token: token
					}
					, url: _url + 'ajax/ajax.new_password.php'
					, success: function (data) {
						if (data == 1) {
							$('.m-content__retrieve .m-login__head').append('<span class="messaggio-errore">'+_translations['new_password']+'</span>');
						}
						else if (data == 0) {
							$('.m-content__retrieve .m-login__head').append('<span class="messaggio-errore">'+_translations['error_occur']+'</span>');
						}
						else {
							$(window.location).attr('href', data);
						}
					}
				});
			}
			else {
				$('.m-content__retrieve .m-login__head').append('<span class="messaggio-errore">'+_translations['passwords_not_match']+'</span>');
			}
		}
		else {
			$('.m-content__retrieve .m-login__head').append('<span class="messaggio-errore">'+_translations['password_length']+'</span>');
		}
	}

	doRegistration(){
		var errore= 0;
		var nome;
		var tipo;
		var valore;
		var confronto_email;
		var confronto_pass;
		let _this;
		var required;

		required = this.formRegistration.find('.input__required');


		required.each(function(){
			_this= $(this);

			_this.removeClass('input__error');
			_this.closest('span').removeClass('input__check-error');
			_this.parent().find('a').removeClass('input__check-error');

			nome= _this.attr('name');
			tipo= _this.attr('type');
			valore= _this.val();

			if(tipo == 'text'){
				if(valore == '' && valore.replace(' ', '') == '' ){
					errore= 1;
					_this.addClass('input__error');
				}
			}else if(tipo == 'number'){
				if(valore == '' && valore.replace(' ', '') == '' && !$.isNumeric(valore)){
					errore= 1;
					_this.addClass('input__error');
				}
			}else if(tipo == 'email'){
				if(isEmail(valore)){
					if(nome == 'acc_mail'){
						confronto_email= valore;
					}else if(nome == 'acc_conferma_mail'){
						if( confronto_email != valore ){
							_this.addClass('input__error');
							errore= 1;
						}   
					}
				}else{
					_this.addClass('input__error');
					errore=1;
				}
			}else if(tipo == 'password'){
				if(valore.length >= 8){
					if(nome == 'acc_pass'){
						confronto_pass= valore;
					}else if(nome == 'acc_conferma_pass'){
						if( confronto_pass != valore ){
							_this.addClass('input__error');
							errore= 1;
						}   
					}
				}else{
					_this.addClass('input__error');
					errore=1;
				}
			}else if(tipo == 'checkbox'){
				if(!_this.is(':checked')){
					_this.closest('span').addClass('input__check-error');
					_this.parent().find('a').addClass('input__check-error');
					errore= 1;
				}
			}

		});

		if(errore == 0){
			this.formRegistration.submit();
		}
	}
}

function isEmail(email) {
	var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
	return regex.test(email);
}


// WEBPACK FOOTER //
// ./src/js/modules/modal.js